<template>
  <TableComp
    :headers="headers"
    name="Credits"
    :status="credits.status"
    :pagination="credits.pagination"
    :sort="credits.sort"
    :number-of-items="credits.list.length"
    :header-actions="headerActions"
    :empty-actions="headerActions"
    v-on:update:list="updateList"
  >
    <template v-slot:desktop>
      <TableRow v-for="credit in credits.list" v-bind:key="credit.id">
        <td class="align-middle">
          <router-link :to="{ name: 'credit-detail', params: { id: credit.id } }">
            {{ credit.formattedDescription }}
          </router-link>
        </td>
        <td class="align-middle text-center">
          <Pill :content="credit.formattedStatus" :variant="getStatusVariant(credit.status)" />
        </td>
        <td class="align-middle text-center">{{ credit.formattedDate }}</td>
        <td class="align-middle text-center">{{ moneyFormat(credit.amount) }}</td>
        <td class="align-middle text-center">{{ moneyFormat(credit.remainingAmount) }}</td>
      </TableRow>
    </template>
    <template v-slot:mobile>
      <TableMobileRow v-for="credit in credits.list" v-bind:key="credit.id">
        <template #header>
          <router-link :to="{ name: 'credit-detail', params: { id: credit.id } }">
            {{ credit.formattedDescription }}
          </router-link>
        </template>

        <template #content>
          <!-- status -->
          <div class="row">
            <div class="col">{{ $t("global.status") }}:</div>
            <div class="col">
              <Pill :content="credit.formattedStatus" :variant="getStatusVariant(credit.status)" />
            </div>
          </div>
          <!-- date -->
          <div class="row">
            <div class="col">{{ $t("global.date") }}:</div>
            <div class="col">
              {{ credit.formattedDate }}
            </div>
          </div>
          <!-- amount -->
          <div class="row">
            <div class="col">{{ $t("global.amount") }}:</div>
            <div class="col">{{ moneyFormat(credit.amount) }}</div>
          </div>
          <!-- remaining -->
          <div class="row">
            <div class="col">{{ $t("global.remaining") }}:</div>
            <div class="col">{{ moneyFormat(credit.remainingAmount) }}</div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import CreditRedeem from "@/components/smart/modals/CreditRedeem";
import { getStatusVariant } from "@/utils/statusVariant";
import { moneyFormat } from "leatherman-js/utils/formatters/money";
import NavLink from "@/classes/NavLink";
import Pill from "@/components/display/Pill";
import store from "@/store";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import TableRow from "@/components/display/table/TableRow";

export default {
  name: "CreditsTable",
  props: {
    credits: Object,
  },
  components: {
    Pill,
    TableComp,
    TableMobileRow,
    TableRow,
  },
  setup(props, { root }) {
    const headers = [
      new TableHeader(root.$t("global.description"), undefined),
      new TableHeader(root.$t("global.status"), "justify-content-center"),
      new TableHeader(root.$t("global.date"), "justify-content-center"),
      new TableHeader(root.$t("global.amount"), "justify-content-center"),
      new TableHeader(root.$t("global.remaining"), "justify-content-center"),
    ];

    const redeemCredit = () => {
      store.dispatch("modals/open", {
        template: CreditRedeem,
      });
    };

    const headerActions = [
      new NavLink(root.$t("global.redeem-promo-code"), "add", redeemCredit, false, null, "epsilon"),
    ];

    const updateList = (event) => {
      const { pagination, sort } = event;
      store.dispatch("credits/getList", {
        pageIndex: pagination?.index,
        pageSize: pagination?.size,
        sortProperty: sort?.property,
        sortDirection: sort?.direction,
      });
    };

    return {
      getStatusVariant,
      headers,
      moneyFormat,
      updateList,
      headerActions,
    };
  },
};
</script>
